import { initCarousel } from '../../_shared/carousel';

initCarousel('property-content__roomplan-slider');

document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll<HTMLElement>('.wp-block-ocean-property-content');

	blocks.forEach((block) => {
		const showMoreButton = block.querySelector<HTMLButtonElement>('.property-content__show-more');
		const more = block.querySelector<HTMLElement>('.property-content__more');
		if (!showMoreButton || !more)
			{
			return;
			}

		showMoreButton.addEventListener('click', () => {
			const isOpen = more.classList.toggle('is-open');
			block.classList.toggle('is-expanded', isOpen);
			showMoreButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

			// Collapsing from below the fold would otherwise leave the
			// viewport stranded in whitespace where the content used to be.
			if (!isOpen && showMoreButton.getBoundingClientRect().top < 0)
				{
				showMoreButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
			});
		});

	// Floor plan heading doubles as the caption for whichever plan is on
	// show. Only when captions are trusted for this property (the same
	// show_gallery_captions gate the gallery uses) -- otherwise the heading
	// stays the plain "Floor plan(s)" the server rendered, and a plan with no
	// caption of its own falls back to it too.
	document.querySelectorAll<HTMLElement>('.property-content__roomplan').forEach((roomplan) => {
		if (roomplan.dataset.showCaptions !== '1')
			{
			return;
			}

		const title = roomplan.querySelector<HTMLElement>('.property-content__roomplan-title');
		const track = roomplan.querySelector<HTMLElement>('.property-content__roomplan-slider__track');
		const cards = Array.from(roomplan.querySelectorAll<HTMLElement>('.property-content__roomplan-slider__card'));
		if (!title || !track || cards.length < 2)
			{
			return;
			}

		const fallback = roomplan.dataset.fallbackTitle || '';

		const syncTitle = () => {
			// Whichever card's left edge is nearest the track's -- the one the
			// scroll has settled on.
			const trackLeft = track.getBoundingClientRect().left;
			let nearest = cards[0];
			let shortest = Infinity;

			cards.forEach((card) => {
				const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
				if (distance < shortest)
					{
					shortest = distance;
					nearest = card;
					}
				});

			title.textContent = nearest.dataset.caption || fallback;
			};

		let frame = 0;
		track.addEventListener('scroll', () => {
			cancelAnimationFrame(frame);
			frame = requestAnimationFrame(syncTitle);
			});
		});
	});
